import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";



function Mumbaioutstaioncabs() {



const cardData = {
  keyword: "Mumbai Outstation Cabs",
  heading: "Omshree Cab: Mumbai Outstation Cabs",

  headingDescription:
    "Omshree Cab provides dependable and comfortable Mumbai Outstation Cabs for travelers looking to explore destinations beyond the city with ease and convenience. Whether you are planning a family vacation, corporate trip, pilgrimage journey, or weekend getaway, our outstation cab service from Mumbai offers safe travel with professional drivers and well-maintained vehicles. We provide flexible options including one-way outstation drops, round-trip bookings, multi-day travel packages, and customized itineraries at transparent per-kilometer pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for individuals, families, and group travel. With experienced chauffeurs trained for long-distance and highway driving, Omshree Cab ensures a smooth and stress-free journey to popular destinations like Lonavala, Mahabaleshwar, Shirdi, Pune, Nashik, and more. With punctual pickup from anywhere in Mumbai and 24/7 customer support, Omshree Cab is your trusted choice for reliable and affordable Mumbai outstation cab services.",

  top: "Top Places to Visit in Mumbai Outstation with Omshree Cab",

  topPlaces: [
  {
    title: "Lonavala",
    description:
      "Lonavala is a popular hill station near Mumbai, famous for lush greenery, waterfalls, and forts. Mumbai to Lonavala cab service ensures a comfortable 2–3 hour drive with scenic views. Our professional drivers coordinate stopovers for local sightseeing like Bhushi Dam and Tiger’s Leap. Ideal for family trips and weekend getaways. Omshree Cab offers a relaxed and punctual travel experience."
  },
  {
    title: "Mahabaleshwar",
    description:
      "Mahabaleshwar is a serene hill station known for strawberry farms, viewpoints, and historic temples. Our Mumbai cab service provides a safe and comfortable 5–6 hour journey. Flexible stops at Mapro Garden, Venna Lake, and other attractions make the trip enjoyable for families and couples alike."
  },
  {
    title: "Matheran",
    description:
      "Matheran is a charming eco-sensitive hill station famous for its toy train, viewpoints, and tranquil environment. Mumbai to Matheran cab service allows hassle-free travel with drop-off near the entry points. Comfortable AC vehicles make the winding hill drive safe and relaxing, perfect for day trips or overnight stays."
  },
  {
    title: "Alibaug",
    description:
      "Alibaug is a coastal town known for beaches, forts, and water sports. Our chauffeur-driven cab service ensures a smooth 3–4 hour drive from Mumbai. Flexible sightseeing stops at Alibaug Beach, Kolaba Fort, and Kihim Beach make it ideal for family or friends’ getaways, ensuring a comfortable and enjoyable trip."
  },
  {
    title: "Khandala",
    description:
      "Khandala is a scenic hill station close to Lonavala, famous for waterfalls, valleys, and trekking trails. Mumbai to Khandala cab service provides comfortable rides and optional sightseeing stops like Duke’s Nose and Rajmachi Fort. Ideal for weekend trips with friends and families seeking nature and adventure."
  },
  {
    title: "Pune Outstation",
    description:
      "Pune is a cultural hub with historical forts, museums, and hill stations nearby. Mumbai to Pune cab service ensures a 3–4 hour comfortable drive with AC vehicles. Flexible drop-offs at Shaniwar Wada, Aga Khan Palace, or Sinhagad Fort make it perfect for same-day or overnight trips from Mumbai."
  },
  {
    title: "Igatpuri",
    description:
      "Igatpuri is a tranquil hill station known for Vipassana meditation centers, waterfalls, and forts. Our Mumbai cab service provides a comfortable 3–4 hour journey with scenic highway views. Optional stops at Tringalwadi Fort and Camel Valley enhance the overall travel experience for families and solo travelers."
  },
  {
    title: "Lavasa",
    description:
      "Lavasa is a planned hill city offering boating, lakeside walks, and leisure activities. Mumbai to Lavasa cab service ensures timely arrival with AC comfort and flexible sightseeing options. Ideal for families and couples looking for a relaxing outstation getaway close to nature."
  },
  {
    title: "Nashik",
    description:
      "Nashik is famous for vineyards, temples, and the Godavari river ghats. Mumbai to Nashik cab service ensures a smooth 4–5 hour drive with comfortable vehicles. Flexible visits to Sula Vineyards, Trimbakeshwar Temple, and other attractions make it perfect for weekend spiritual and leisure trips."
  },
  {
    title: "Dapoli",
    description:
      "Dapoli is a quiet coastal town in Konkan, known for beaches, temples, and historical forts. Our Mumbai cab service ensures a safe and comfortable 6–7 hour drive. Optional stops at Murud Beach, Karde Beach, and Suvarnadurg Fort make it ideal for family trips seeking relaxation and sightseeing."
  }
],

services: [
{
name: "Mumbai Outstation Cabs",
description: "Mumbai outstation cab service provides reliable transportation from Mumbai to major cities and tourist destinations. Comfortable AC vehicles and experienced drivers ensure safe highway travel. Ideal for family trips, business travel, and weekend getaways. Pickup is available from homes, hotels, offices, and airport locations across Mumbai. Transparent pricing and flexible travel options make long-distance journeys convenient. Omshree Cab guarantees punctual service and smooth outstation travel experience."
},
{
name: "Outstation Cab Service Mumbai",
description: "Outstation cab service in Mumbai offers dependable intercity transportation for travelers planning trips outside the city. Our fleet includes sedan, SUV, and luxury vehicles suitable for all travel needs. Professional drivers ensure safe highway driving and comfortable long-distance journeys. Customers can schedule pickups anytime with easy booking support. Perfect for family vacations, corporate travel, and pilgrimage tours."
},
{
name: "Mumbai Outstation Taxi Service",
description: "Mumbai outstation taxi service provides convenient long-distance travel from Mumbai to nearby cities and tourist destinations. AC vehicles with trained drivers ensure safe and comfortable journeys. Flexible pickup options are available from homes, hotels, and airports. Ideal for leisure trips, religious tours, and business travel. Omshree Cab offers reliable taxi service with transparent fare and professional support."
},
{
name: "Outstation Car Rental Mumbai",
description: "Outstation car rental in Mumbai offers flexible vehicle options for travelers planning long-distance journeys. Customers can choose from sedan, SUV, and premium vehicles depending on travel requirements. Clean interiors and experienced drivers provide comfortable highway travel. Suitable for family vacations, business trips, and weekend getaways. Easy booking and affordable pricing make outstation travel hassle-free."
},
{
name: "One Way Outstation Cab Mumbai",
description: "One way outstation cab from Mumbai allows passengers to travel to another city without paying return charges. This option reduces travel costs while providing comfortable and reliable transportation. AC vehicles and professional drivers ensure smooth highway journeys. Ideal for airport drops, relocation travel, or one-way business trips. Transparent per-km pricing ensures fair billing."
},
{
name: "Mumbai Outstation Taxi Booking",
description: "Mumbai outstation taxi booking service allows passengers to reserve vehicles easily for long-distance travel. With instant confirmation and flexible pickup locations, travel planning becomes simple. AC cars and experienced drivers ensure comfortable highway journeys. Suitable for family travel, pilgrimage trips, and corporate visits. Omshree Cab ensures dependable taxi booking for outstation travel."
},
{
name: "Mumbai to Outstation Cab",
description: "Mumbai to outstation cab service offers convenient travel from Mumbai to cities like Pune, Shirdi, Nashik, Lonavala, and more. Well-maintained vehicles provide comfortable seating for long journeys. Professional drivers ensure safe and smooth travel on highways. Ideal for weekend tours, family vacations, and religious trips. Flexible booking and transparent pricing ensure stress-free travel."
},
{
name: "Taxi Service in Mumbai for Outstation",
description: "Taxi service in Mumbai for outstation travel provides reliable transportation for passengers traveling beyond city limits. Comfortable AC vehicles ensure smooth long-distance journeys. Experienced drivers manage highway routes safely and efficiently. Suitable for business travel, family trips, and pilgrimage tours. Easy booking and transparent fare structure make travel convenient."
},
{
name: "Best Outstation Cab Service Mumbai",
description: "Best outstation cab service in Mumbai focuses on customer comfort, safe travel, and reliable transportation. Clean vehicles and professional drivers ensure high-quality service for long journeys. Pickup is available from all areas in Mumbai including airport and railway stations. Ideal for tourists, families, and corporate clients. Omshree Cab offers trusted intercity travel experience."
},
{
name: "Cheap Outstation Cab Mumbai",
description: "Cheap outstation cab in Mumbai offers affordable travel options for passengers looking for economical intercity transportation. Competitive pricing ensures cost-effective travel without compromising comfort. AC vehicles and trained drivers provide smooth highway journeys. Ideal for students, small families, and budget travelers. Transparent pricing ensures no hidden charges."
},
{
name: "Mumbai Outstation Cab Booking Online",
description: "Mumbai outstation cab booking online allows passengers to reserve vehicles instantly from anywhere. The simple booking system provides quick confirmation and travel details. AC sedans and SUVs are available for comfortable long-distance travel. Ideal for urgent trips, business travel, and family tours. Online booking ensures easy travel planning and reliable service."
},
{
name: "Mumbai Airport Outstation Cab",
description: "Mumbai airport outstation cab service provides direct intercity travel from the airport to major destinations. Ideal for passengers arriving in Mumbai who need immediate outstation transportation. Comfortable vehicles and professional drivers ensure smooth highway journeys. Perfect for business travelers and tourists. Omshree Cab ensures punctual airport pickups and safe travel."
},
{
name: "Innova Outstation Cab Mumbai",
description: "Innova outstation cab in Mumbai is ideal for families and group travelers who need spacious seating and luggage capacity. The premium MPV provides comfortable seating for long highway journeys. Smooth suspension and AC comfort ensure relaxed travel. Suitable for pilgrimage tours, family trips, and corporate travel. Professional drivers ensure safe driving."
},
{
name: "Ertiga Outstation Taxi Mumbai",
description: "Ertiga outstation taxi in Mumbai offers comfortable seating for medium-size families traveling long distances. Spacious interiors and smooth driving performance make it suitable for highway travel. AC comfort and professional drivers ensure stress-free journeys. Ideal for weekend trips and religious tours. Affordable pricing makes Ertiga a popular choice."
},
{
name: "Sedan Outstation Cab Mumbai",
description: "Sedan outstation cab in Mumbai provides economical travel for small families and solo travelers. Vehicles like Swift Dzire and Etios offer comfortable seating and fuel-efficient travel. AC comfort ensures relaxed long-distance journeys. Ideal for city-to-city travel and business trips. Professional drivers ensure safe and timely transportation."
},
{
name: "SUV Outstation Taxi Mumbai",
description: "SUV outstation taxi in Mumbai is perfect for group travelers needing extra space and luggage capacity. Powerful vehicles ensure stable performance on highways and hill routes. Spacious seating ensures comfort during long journeys. Ideal for family vacations and adventure trips. Professional drivers guarantee safe and smooth travel."
},
{
name: "Luxury Outstation Cab Mumbai",
description: "Luxury outstation cab service in Mumbai offers premium travel comfort for passengers seeking high-end transportation. Premium vehicles provide spacious interiors and superior ride quality. Ideal for VIP guests, corporate travel, and luxury holiday trips. Professional chauffeurs ensure smooth and safe driving. Omshree Cab delivers executive-level travel experience."
},
{
name: "Corporate Outstation Cab Mumbai",
description: "Corporate outstation cab service in Mumbai is designed for business travel and company transportation needs. Professional drivers ensure punctual pickup and smooth travel for executives and teams. Comfortable vehicles support long business trips and meetings. Flexible booking options allow companies to manage travel easily. Reliable service ensures professional transportation."
}
],

tableData: [
["Mumbai Outstation Cabs","Outstation Cab Service Mumbai"],
["Mumbai Outstation Taxi Service","Outstation Car Rental Mumbai"],
["One Way Outstation Cab Mumbai","Mumbai Outstation Taxi Booking"],
["Mumbai to Outstation Cab","Taxi Service in Mumbai for Outstation"],
["Best Outstation Cab Service Mumbai","Cheap Outstation Cab Mumbai"],
["Mumbai Outstation Cab Booking Online","Mumbai Airport Outstation Cab"],
["Innova Outstation Cab Mumbai","Ertiga Outstation Taxi Mumbai"],
["Sedan Outstation Cab Mumbai","SUV Outstation Taxi Mumbai"],
["Luxury Outstation Cab Mumbai","Corporate Outstation Cab Mumbai"]
],

whychoose: [
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our professionally trained drivers have years of experience driving long-distance routes, ensuring not only safety but also smooth, stress-free journeys. They are well-versed in highway traffic patterns, road conditions, and shortcut routes, making your travel faster and more comfortable."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "We offer clear, per-kilometer fares with no hidden charges or unexpected fees. Our pricing structure is fully disclosed at the time of booking, so you can plan your travel budget confidently and enjoy peace of mind throughout your journey."
  },
  {
    WhyChooseheading: "24/7 Availability",
    WhyChoosedescription: "Omshree Cabs is at your service around the clock, offering flexible bookings for early morning departures, late-night returns, or emergency trips. Our customer support team is always ready to assist with scheduling, route information, or any travel queries."
  },
  {
    WhyChooseheading: "Clean AC Vehicles",
    WhyChoosedescription: "Our fleet of well-maintained, air-conditioned vehicles undergoes regular cleaning and sanitization to ensure hygienic and comfortable rides. Every car is equipped for long-distance travel, providing a smooth and refreshing experience even on hot or humid days."
  },
  {
    WhyChooseheading: "Flexible Travel Options",
    WhyChoosedescription: "Choose from one-way trips, round trips, or same-day return journeys based on your travel needs. We adapt to your schedule and can adjust pickup times or stops to ensure your journey is as convenient and stress-free as possible."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a wide range of vehicles including sedans, SUVs, and luxury cars to suit different group sizes and comfort preferences. Whether you are traveling solo, with family, or in a group, we have the perfect vehicle for your outstation journey."
  },
  {
    WhyChooseheading: "Doorstep Pickup",
    WhyChoosedescription: "We provide convenient pickup from any location in Mumbai, so you don’t have to worry about reaching a cab stand or terminal. Our drivers arrive on time at your preferred location, making your journey seamless from start to finish."
  },
  {
    WhyChooseheading: "Reliable Service",
    WhyChoosedescription: "Punctuality and professionalism are at the core of our service. Omshree Cabs ensures that you reach your destination on time, with drivers following safe driving practices and providing courteous assistance throughout the journey."
  }
]
};



const faqData = [
  { question: "How long does Mumbai outstation travel take?", answer: "Travel time depends on the destination, typically ranging from 4–8 hours for nearby cities and longer for distant locations." },
  { question: "Is same-day return possible?", answer: "Yes, we offer same-day return packages for popular nearby destinations." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, every vehicle in our fleet is fully air-conditioned for a comfortable journey." },
  { question: "Do you provide SUV and premium options?", answer: "Yes, spacious SUVs and premium vehicles are available for outstation trips." },
  { question: "Is pricing per km transparent?", answer: "Yes, we share a clear per-kilometer rate before booking to ensure transparency." },
  { question: "Can I book online?", answer: "Yes, instant online booking is supported via our website or app." },
  { question: "Are waiting charges applicable?", answer: "Waiting charges are only applied for extended delays beyond agreed package terms." },
  { question: "Can I customize the return schedule?", answer: "Yes, return timings can be customized as per your convenience." },
  { question: "Are corporate bookings allowed?", answer: "Yes, we accommodate corporate and group outstation bookings." },
  { question: "Are vehicles sanitized for safety?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Mehta",
    feedback:
      "Used Omshree Cabs for a Mumbai to Pune outstation trip. Comfortable ride, punctual driver, and hassle-free booking. Perfect for long-distance travel.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Shilpa Patil",
    feedback:
      "We booked an SUV for our family trip from Mumbai to Lonavala. The vehicle was spacious and clean, and the driver was courteous. Transparent pricing and excellent service.",
    rating: 5
  }
];






























































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Outstation Cabs",
  "description": "Book Mumbai Outstation Cabs with Omshree Cab for outstation trips, corporate travel, airport transfers, and local tours. Choose from Innova, Ertiga, Sedan, SUV, and luxury cabs at affordable rates. Hassle-free booking online or via contact. Your trusted Mumbai outstation cab service!",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4300"
  }
};





  return (
    <div>
      <Helmet>
  <title>Mumbai Outstation Cabs | Contact: +91 9892544084</title>
  <meta 
    name="description" 
    content="Book Mumbai Outstation Cabs with Omshree Cab for outstation trips, corporate travel, airport transfers, and local tours. Choose from Innova, Ertiga, Sedan, SUV, and luxury cabs at affordable rates. Hassle-free booking online or via contact. Your trusted Mumbai outstation cab service!" 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/1.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
             <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaioutstaioncabs;